import { render, staticRenderFns } from "./Auction.vue?vue&type=template&id=4bdcff28&scoped=true&"
import script from "./Auction.vue?vue&type=script&lang=js&"
export * from "./Auction.vue?vue&type=script&lang=js&"
import style0 from "./Auction.vue?vue&type=style&index=0&id=4bdcff28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcff28",
  null
  
)

export default component.exports